module.exports = __webpack_public_path__ + "static/img/role.8eab419.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/yjyx/role.png
// module id = mEdB
// module chunks = 7